export default __webpack_public_path__ + "static/media/KOD0034-min.1c6c22fa.webp";